import { useEffect, useState } from "react";
import { authApi, tokenStorage, userStorage, tenantStorage, organizationsStorage, tenantRolesStorage } from "../../services/apiClient";
import { APP_FONT_FAMILY } from "../../shared/theme";

export default function ConfirmOrganizationDeletionPage() {
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (!token || !token.trim()) {
      setStatus("error");
      setMessage("Lien incomplet : paramètre token manquant.");
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const data = await authApi.confirmOrganizationDeletion(token.trim());
        if (cancelled) return;
        tokenStorage.clear();
        userStorage.clear();
        tenantStorage.clear();
        organizationsStorage.clear();
        tenantRolesStorage.clear();
        setStatus("ok");
        setMessage(data?.message || "Organisation supprimée.");
        const url = new URL(window.location.href);
        url.searchParams.delete("token");
        url.searchParams.delete("page");
        window.history.replaceState({}, "", url.pathname + url.search);
      } catch (e) {
        if (cancelled) return;
        setStatus("error");
        setMessage(e?.message || "Confirmation impossible.");
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: APP_FONT_FAMILY,
        background: "#f8fafc",
        padding: 24,
      }}
    >
      <div
        style={{
          maxWidth: 440,
          background: "#fff",
          borderRadius: 14,
          border: "1px solid #e2e8f0",
          padding: "28px 26px",
          boxShadow: "0 12px 40px rgba(15,23,42,0.08)",
        }}
      >
        <h1 style={{ fontSize: 18, fontWeight: 800, margin: "0 0 12px", color: "#0f172a" }}>
          Suppression d’organisation
        </h1>
        {status === "loading" ? (
          <p style={{ margin: 0, color: "#64748b", fontSize: 14 }}>Confirmation en cours…</p>
        ) : (
          <p
            style={{
              margin: 0,
              fontSize: 14,
              lineHeight: 1.55,
              color: status === "ok" ? "#065f46" : "#991b1b",
            }}
          >
            {message}
          </p>
        )}
        {status === "ok" ? (
          <p style={{ margin: "14px 0 0", fontSize: 13, color: "#64748b" }}>
            Vous pouvez vous reconnecter pour accéder à vos autres organisations.
          </p>
        ) : null}
      </div>
    </div>
  );
}
